export default "./dist/stdassets/images/icons/ui-menu.png";